import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { DateRangeSelection } from '@shared/components'
import React, { FC } from 'react'

type Props = {
  currentFilters: HomeFilters
}

export const MoveOutSelection: FC<Props> = ({ currentFilters }) => {
  const [, workspaceDispatch] = useWorkspaceContext()
  const { moveOutEndDate, moveOutStartDate, moveInEndDate, moveInStartDate, reservationType } = currentFilters

  const moveOutDisabled = reservationType === 'Flexible' || reservationType === 'Standby' || !moveInStartDate
  const maxMoveInStartDate = moveInStartDate ? (moveInEndDate ? moveInEndDate : moveInStartDate) : undefined
  const reservationTypeDisableMsg =
    reservationType === 'Flexible' || reservationType === 'Standby'
      ? `Move out disabled for ${reservationType} type booking`
      : undefined
  const moveInDisableMsg = 'Move In Date needs to be selected first.'
  const disabledMessage = !moveInStartDate ? moveInDisableMsg : reservationTypeDisableMsg

  return (
    <DateRangeSelection
      disabled={moveOutDisabled}
      disabledMessage={disabledMessage}
      endDate={moveOutEndDate}
      maxMoveInStartDate={maxMoveInStartDate}
      setEndDate={(d?: Date) => workspaceDispatch(WorkspaceAction.updateFilters({ moveOutEndDate: d }))}
      setStartDate={(d?: Date) => workspaceDispatch(WorkspaceAction.updateFilters({ moveOutStartDate: d }))}
      startDate={moveOutStartDate}
    />
  )
}
